import './popup.scss';

import Component from '../../components/component/component';
import Helpers from '../../components/helpers/helpers';
import Cookie from '../../utilities/cookie/cookie';

export default class Popup extends Component {
    static initSelector: string = '.js-popup';

    closeButton: JQuery;
    popupName: string;
    appearTimeout: number;

    constructor(element: HTMLElement) {
        super(element);

        this.closeButton = this.element.find('.popup__close-button');

        this.popupName = this.element.data('name');

        if (this.shouldShow()) {
            this.appearTimeout = window.setTimeout(this.init.bind(this), parseInt(this.element.data('time')) * 1000);
        } else {
            this.remove();
        }
    }

    init(): void {
        this.element.addClass('is-visible');
        this.closeButton.on('click', this.remove.bind(this));
    }

    getCookieName(): string {
        return `volta_hide_popup_${this.popupName}`;
    }

    shouldShow(): boolean {
        if (Helpers.isLightWeightMode() || !this.popupName) {
            return false;
        }

        return Cookie.get(this.getCookieName()) !== 'yes';
    }

    remove(): void {
        Cookie.set(this.getCookieName(), 'yes', 1);

        this.element.remove();
    }

    destroy(): void {
        window.clearTimeout(this.appearTimeout);
    }
}
